// Particle animation for hero section
export function initializeParticles(): void {
  const particlesContainer = document.getElementById('particles');
  if (!particlesContainer) return;

  for (let i = 0; i < 50; i++) {
    const particle = document.createElement('div');
    particle.className = 'particle';
    particle.style.left = Math.random() * 100 + '%';
    particle.style.animationDelay = Math.random() * 20 + 's';
    particle.style.animationDuration = 15 + Math.random() * 10 + 's';
    particlesContainer.appendChild(particle);
  }
}
